declare const PACKAGE_VERSION: string;

export const packageVersion = typeof PACKAGE_VERSION === 'string' ? PACKAGE_VERSION : 'development';
